import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  ipv4: 'IPv4',
  ipv6: 'IPv6',
  domain: 'Domain',
  tld: 'Top-Level Domain',
  cidr: 'CIDR',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Asset class
 * Translates between API lowercase values and UI capitalized values
 */
export const AssetClass: SimpleFilterDefinition = {
  apiField: 'class',
  uiField: 'Class',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve(['IPv4', 'IPv6', 'Domain', 'Top-Level Domain', 'CIDR']),
  operators: ['is', 'is not', 'is any of'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Class',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'class',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
